import { render, staticRenderFns } from "./ShipmentRequests.vue?vue&type=template&id=cc463194"
import script from "./ShipmentRequests.vue?vue&type=script&lang=js"
export * from "./ShipmentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports